import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSpreadsheet from './components/AboutSpreadsheet';
import ComparisonSection from './components/ComparisonSection';
import AuthoritySection from './components/AuthoritySection';
import SafetySection from './components/SafetySection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const FAVICON_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png';

function getSiteUrl(): string {
  const env = import.meta.env as Record<string, string>;
  return (env.VITE_SITE_URL as string) || window.location.origin;
}

function homepageSchema() {
  const siteUrl = getSiteUrl();
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'Superbuy Spreadsheet',
        url: siteUrl,
        description:
          'The ultimate resource hub for Superbuy Spreadsheet - product guides, QC tips, comparison tools and expert shopping strategies.',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: 'Superbuy Spreadsheet',
        url: siteUrl,
        logo: FAVICON_URL,
        description:
          'The world\'s most comprehensive Superbuy Spreadsheet resource platform, combining spreadsheet databases, shopping guides, product discovery resources, comparison tools, and safety education.',
        sameAs: ['https://kaspreadsheet.com'],
      },
    ],
  };
}

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema()) }}
      />
      <main className="min-h-screen">
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <AboutSpreadsheet />
        <ComparisonSection />
        <AuthoritySection />
        <SafetySection />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}